import React, { useState, useEffect } from 'react';
import { Descriptions, Image, Row, Col, Divider, Typography } from 'antd';
import { POST } from "../../../../services/index";
import { CASE1_TYPE_LABELS } from "../../../../data/constant";

const { Title, Text } = Typography;

const CaseSummary = ({ data }) => {
    const [labels, setLabels] = useState({ c1: "-", c2: "-", c3: "-" });

    useEffect(() => {
        const fetchNames = async () => {
            if (!data) return;

            // Resolve Case 1 Name
            const c1 = CASE1_TYPE_LABELS[data.case1] || CASE1_TYPE_LABELS[Number(data.case1)] || "-";

            let c2 = "-";
            let c3 = "-";

            try {
                // Fetch Case 2 list to find the name for data.case2
                if (data.case1 && data.case2) {
                    const res2 = await POST(`/api/v1/importInputAudit/listCase1`, { case1: data.case1 });
                    const list2 = res2?.result || [];
                    const found2 = list2.find(item => String(item.id) === String(data.case2));
                    if (found2) {
                        c2 = found2.casename || found2.name;
                    }
                }

                // Fetch Case 3 list to find the name for data.case3
                if (data.case2 && data.case3) {
                    const res3 = await POST(`/api/v1/importInputAudit/listCase2`, { case2: data.case2 });
                    const list3 = res3?.result || [];
                    const found3 = list3.find(item => String(item.id) === String(data.case3));
                    if (found3) {
                        c3 = found3.casename || found3.name;
                    }
                }
            } catch (error) {
                console.error("Failed to fetch case names in summary:", error);
            }

            setLabels({ c1, c2, c3 });
        };

        fetchNames();
    }, [data]);

    if (!data) return null;

    const renderCustomFields = (customFields) => {
        if (!customFields || !Array.isArray(customFields)) return null;

        return customFields.map((field, index) => {
            const { title, value } = field;

            const isImages = Array.isArray(value) && value.length > 0 &&
                (typeof value[0] === 'string' && (value[0].startsWith('data:image') || value[0].startsWith('http')));

            if (isImages) {
                return (
                    <Descriptions.Item key={index} label={title} span={3}>
                        <div style={{ marginTop: 8 }}>
                            <Row gutter={[8, 8]}>
                                {value.map((img, imgIdx) => (
                                    <Col key={imgIdx} xs={12} sm={8} md={6}>
                                        <Image
                                            width="100%"
                                            src={img}
                                            alt={`${title} ${imgIdx + 1}`}
                                            style={{ borderRadius: 4, border: '1px solid #f0f0f0' }}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Descriptions.Item>
                );
            } else {
                return (
                    <Descriptions.Item key={index} label={title} span={3}>
                        {Array.isArray(value) ? value.join(', ') : String(value || "-")}
                    </Descriptions.Item>
                );
            }
        });
    };

    return (
        <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '4px' }}>
            <Title level={5}>สรุปข้อมูลรายการ</Title>
            <Descriptions bordered size="small" column={2}>
                <Descriptions.Item label="ประเภทการทำรายการ" span={2}>
                    {data.radioChoice === "1" ? <Text type="success">เติม</Text> : <Text type="danger">ไม่เติม</Text>}
                </Descriptions.Item>
                <Descriptions.Item label="Case 1" span={2}>
                    {labels.c1}
                </Descriptions.Item>
                <Descriptions.Item label="Case 2" span={2}>
                    {labels.c2}
                </Descriptions.Item>
                <Descriptions.Item label="Case 3" span={2}>
                    {labels.c3}
                </Descriptions.Item>
                <Descriptions.Item label="จำนวน (Amount)" span={2}>
                    <Text style={{ fontSize: '16px' }}>
                        {data.amount || "-"}
                    </Text>
                </Descriptions.Item>
                <Descriptions.Item label="Transaction ID" span={2}>{data.transactionId || "-"}</Descriptions.Item>
                <Descriptions.Item label="เวลา (Time)">{data.timeDeposit || "-"}</Descriptions.Item>
                <Descriptions.Item label="วันที่ (Date)">{data.dateDeposit || "-"}</Descriptions.Item>
            </Descriptions>

            {data.customFields && data.customFields.length > 0 && (
                <>
                    <Divider orientation="left" style={{ margin: '16px 0 8px 0' }}>
                        <Title level={5} style={{ margin: 0 }}>ข้อมูลเพิ่มเติม</Title>
                    </Divider>
                    <Descriptions bordered size="small" column={3}>
                        {renderCustomFields(data.customFields)}
                    </Descriptions>
                </>
            )}
        </div>
    );
};

export default CaseSummary;
